import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-redo" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

import { blocklyStore } from '../../../blockly/blocklyStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'RedoButton',
  setup(__props) {

const onRedo = () => blocklyStore.workspace.undo(true);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "btn btn-outline-dark d-md-inline d-none ml-1 mx-1",
    onClick: onRedo
  }, _hoisted_2))
}
}

})